export const COMPLETE_TASK_ERROR_MAP = {
	GRAPHQL_ERROR: { code: 'GRAPHQL_ERROR' },
	NO_DATA_ERROR: { code: 'NO_DATA_ERROR' },
	UNKNOWN_ERROR: { code: 'UNKNOWN_ERROR' },
	UNAUTHORIZED_ERROR: { code: 'UNAUTHORIZED_ERROR' },
} as const;

// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
export const completeTaskErrorCodes = Object.keys(COMPLETE_TASK_ERROR_MAP) as ReadonlyArray<
	keyof typeof COMPLETE_TASK_ERROR_MAP
>;

export type CompleteTaskErrorCode = (typeof completeTaskErrorCodes)[number];
